import { render, staticRenderFns } from "./ProspectSearchBrowse.vue?vue&type=template&id=ec805aa6"
import script from "./ProspectSearchBrowse.vue?vue&type=script&lang=ts"
export * from "./ProspectSearchBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports